import { OnInit, AfterViewInit, ViewChild, ElementRef, Input, OnDestroy, Directive } from '@angular/core';

import * as d3 from 'd3-selection';
import { Subject, fromEvent } from 'rxjs';
import { tap, debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

import { Dimensions } from '../../../models';

@Directive()
export abstract class BaseChartComponent<T> implements OnInit, AfterViewInit, OnDestroy
{
    @Input() dimensions: Dimensions;
    @Input() data: T;
    @ViewChild('container', { static: true }) container: ElementRef;
    protected svgChart: any;
    protected gpeChart: any;
    protected destroyator = new Subject();
    protected abstract initSvg (): void;
    protected abstract drawChart (): void;
    protected xLeft: number;
    protected xRight: number;
    protected yTop: number;
    protected yBottom: number;

    ngOnInit ()
    {
        fromEvent(window, 'resize')
            .pipe(
                debounceTime(250),
                map((event: any) => event.timeStamp),
                distinctUntilChanged(),
                tap(() =>
                {
                    Promise.resolve(null).then(() =>
                    {
                        this.svgChart.select('g')
                            .remove();
                        this.drawChart();
                    });
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngAfterViewInit (): void
    {
        Promise.resolve(null).then(() =>
        {
            this.drawChart();
        });
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    protected baseInitSvg (): void
    {
        const { width, height } = this.container.nativeElement.getBoundingClientRect();

        this.dimensions.width = width;
        this.dimensions.height = height;

        this.dimensions.boundedWidth = Math.max(
            this.dimensions.width - this.dimensions.marginLeft - this.dimensions.marginRight,
            0
        );
        this.dimensions.boundedHeight = Math.max(
            this.dimensions.height - this.dimensions.marginTop - this.dimensions.marginBottom,
            0
        );

        /**
         * Coordonnées quand (0,0) est le centre du graphique
         */
        this.yBottom = height / 2;
        this.yTop = -1 * this.yBottom;
        this.xRight = width / 2;
        this.xLeft = -1 * this.xRight;

        this.svgChart = d3.select(this.container.nativeElement.querySelector('svg'))
            .attr('class', 'svgChart')
            .style('fill', '#FFFFE0');
        this.gpeChart = this.svgChart.insert('g', 'g[aaTooltip]')
            .attr('class', 'gpeChart')
            .attr('transform', 'translate(' + this.dimensions.marginLeft + ',' + this.dimensions.marginTop + ')');
    }
}
